/**
 * @generated SignedSource<<5cbee117db0751a5e7a7f9022d4b3d88>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type row_nativeIssueTable_RowWithSiblingCreate_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"row_nativeIssueTable_MaybeRowWithDragAndDrop_project">;
  readonly " $fragmentType": "row_nativeIssueTable_RowWithSiblingCreate_project";
};
export type row_nativeIssueTable_RowWithSiblingCreate_project$key = {
  readonly " $data"?: row_nativeIssueTable_RowWithSiblingCreate_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"row_nativeIssueTable_RowWithSiblingCreate_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "row_nativeIssueTable_RowWithSiblingCreate_project",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "row_nativeIssueTable_MaybeRowWithDragAndDrop_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "f369449010c90230b9b745c7543e8337";

export default node;
